import { render } from "./text_step.vue?vue&type=template&id=f8ba7cd2"
import script from "./text_step.vue?vue&type=script&lang=js"
export * from "./text_step.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__